import { ReactNode } from 'react';
import { Box, Typography } from 'components/mui';
import { InfoIcon } from 'components/icons';

interface SandboxTourNoteProps {
	children: ReactNode;
}

const SandboxTourNote = ({ children }: SandboxTourNoteProps) => (
	<Box
		sx={{
			mt: 2,
			p: 1.25,
			display: 'flex',
			gap: 1,
			alignItems: 'flex-start',
			borderRadius: 1,
			borderLeft: '3px solid',
			borderColor: 'divider',
			bgcolor: 'action.hover',
		}}
	>
		<InfoIcon
			sx={{
				fontSize: 16,
				mt: '1px',
				color: 'text.disabled',
			}}
		/>
		<Typography variant="caption" color="text.secondary">
			{children}
		</Typography>
	</Box>
);

export default SandboxTourNote;
